import { DynamicGrid } from "../dynamicGrid";
import type { OptionCategoryType } from "../api/optionCategories";
import type { ConnectedEntityFormType } from "./types";
import type { Paths } from "../shared/usePrivacyNavigate";

export const usageLinkTo =
  (paths: Paths, categoryType: OptionCategoryType) => (formType: ConnectedEntityFormType, optionValue: string) => {
    const search = DynamicGrid.optionFilterSearch({ categoryType, optionValue });

    switch (formType) {
      case "REGISTRATIONS":
        return `${paths.registrationsGrid({ variant: "Controller" })}${search}`;
      case "PRIVACY_PROCESSOR_REGISTRATIONS":
        return `${paths.registrationsGrid({ variant: "Processor" })}${search}`;
      case "SYSTEMS":
        return `${paths.systemsGrid()}${search}`;
    }
  };
